import { render, staticRenderFns } from "./userType.vue?vue&type=template&id=e2caaafa&scoped=true&"
import script from "./userType.vue?vue&type=script&lang=js&"
export * from "./userType.vue?vue&type=script&lang=js&"
import style0 from "./userType.vue?vue&type=style&index=0&id=e2caaafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2caaafa",
  null
  
)

export default component.exports